<template>
  <el-scrollbar class="h-100 w-100 overflow">
    <div class="h-100">
      <div class="p-20">
        <div id="report_holder">
        </div>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
import Grh from '@/utils/grhtml5-6.6-min.js'
import reportApi from '@/utils/grwebapp.js'
import axiosx from 'axios'
export default {
  name: 'report',
  components: {},
  data () {
    return {
      sqlStatement: '',
      token: null,
      grf: null,
      id: null,
      type: null,
      starttime: '',
      endtime: '',
      keyword: ''
    }
  },
  created () {
    this.reportViewer = Grh.rubylong.grhtml5.insertReportViewer('report_holder')
    this.reportViewer.dataPrepared = false
  },
  mounted () {
    this.token = this.$route.query.token
    this.grf = this.$route.query.grf
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    this.starttime = this.$route.query.starttime
    this.endtime = this.$route.query.endtime
    this.keyword = this.$route.query.keyword
    this.getReport()
  },
  methods: {
    getReport () {
      let that = this
      axiosx.post(`${this.$store.state.API_URL_9010}/report/getGrf`, this.qs.stringify({
        grf: this.grf
      }), {
        headers: {
          'type': this.type,
          'token': this.token
        }
      }).then(res => {
        if (res.data.success) {
          let jsonObj = that.evil('(' + res.data.data + ')')
          let reportSource = JSON.stringify(jsonObj)
          that.reportViewer.loadReport(reportSource)
          that.sqlStatement = jsonObj.DetailGrid.Recordset.QuerySQL
          that.getReportData()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
      // axiosx({
      //   method: 'post',
      //   url: 'https://www.9lue.com.cn/jlf/report/getGrf',
      //   headers: {
      //     'type': this.type,
      //     'token': this.token
      //   },
      //   params: {
      //     grf: this.grf
      //   }
      // }).then(res => {
      //   if (res.data.success) {
      //     let jsonObj = that.evil('(' + res.data.data + ')')
      //     let reportSource = JSON.stringify(jsonObj)
      //     that.reportViewer.loadReport(reportSource)
      //     that.sqlStatement = jsonObj.DetailGrid.Recordset.QuerySQL
      //     that.getReportData()
      //   } else {
      //     this.$message({
      //       message: res.data.msg,
      //       type: 'error',
      //       offset: 400
      //     })
      //   }
      // })
    },
    getReportData () {
      let that = this
      let params = {
        querySql: that.sqlStatement,
        id: that.id,
        starttime: that.starttime,
        endtime: that.endtime,
        keyword: that.keyword
      }
      if (that.sqlStatement != null && that.sqlStatement !== '') {
        axiosx.post(`${this.$store.state.API_URL_9010}/report/getReportData`, that.qs.stringify(params), {
          headers: {
            'type': this.type,
            'token': this.token
          }
        }).then(res => {
          that.data = res.data
          that.reportViewer.loadData(res.data)
          that.reportViewer.start()
          reportApi.webapp_urlprotocol_startup()
        })
        // axiosx({
        //   method: 'post',
        //   url: 'https://www.9lue.com.cn/jlf/report/getReportData',
        //   headers: {
        //     'type': this.type,
        //     'token': this.token
        //   },
        //   params: {
        //     querySql: that.sqlStatement,
        //     id: that.id,
        //     starttime: that.starttime,
        //     endtime: that.endtime,
        //     keyword: that.keyword
        //   }
        // }).then(res => {
        //   that.data = res.data
        //   that.reportViewer.loadData(res.data)
        //   that.reportViewer.start()
        //   reportApi.webapp_urlprotocol_startup()
        // })
      }
    },
    evil (fn) {
      var Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
      return new Fn('return ' + fn)()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/decisionCenter/report.vue